import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import { AccessGate } from "@/components/AccessGate";
import { SEO } from "@/components/SEO";

function App() {
  return (
    <LanguageProvider>
      <SEO />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessGate>
                <Home />
              </AccessGate>
            }
          />
          <Route path="/legal" element={<Legal />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
